import { render, staticRenderFns } from "./ClientEditTabInfo.vue?vue&type=template&id=5f2f67b2&"
import script from "./ClientEditTabInfo.vue?vue&type=script&lang=js&"
export * from "./ClientEditTabInfo.vue?vue&type=script&lang=js&"
import style0 from "./ClientEditTabInfo.vue?vue&type=style&index=0&id=5f2f67b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports